export enum CType {
    FRACTION="fraction",
    COUNT="count",
}